import { render, staticRenderFns } from "./DocsSectionCard.vue?vue&type=template&id=cb74e2a2&scoped=true"
import script from "./DocsSectionCard.vue?vue&type=script&lang=js"
export * from "./DocsSectionCard.vue?vue&type=script&lang=js"
import style0 from "./DocsSectionCard.vue?vue&type=style&index=0&id=cb74e2a2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb74e2a2",
  null
  
)

export default component.exports